// ==========================================================================
// CACTUS KNIGHT — Warenkorb (Shopify-Version)
// Diese Datei steuert BEIDE Warenkorb-Ansichten mit derselben Logik:
//   1. Das Flyout-Panel (öffnet sich über das Warenkorb-Icon im Header)
//   2. Die eigentliche Warenkorb-Seite (/cart)
//
// GESCHWINDIGKEIT: Ein Klick auf + / − aktualisiert Menge, Zeilensumme und
// Zwischensumme SOFORT im Browser (optimistisch) — ohne auf das Netzwerk zu
// warten. Die Synchronisierung mit Shopify läuft danach GEBÜNDELT im
// Hintergrund: nur EINE Anfrage an /cart/change.js (deren Antwort schon den
// kompletten Warenkorb enthält — kein zweiter /cart.js-Aufruf mehr), und bei
// schnellem Klicken wird nur der ZULETZT gewählte Wert gesendet.
// Antwortet Shopify mit einem abweichenden Wert (z. B. Lagerbestand
// erschöpft), zeichnet die Antwort die Ansicht autoritativ neu.
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  function formatMoney(cents) {
    const value = cents / 100;
    const hasCents = Math.round(value * 100) % 100 !== 0;
    return (
      "€" +
      value.toLocaleString("de-DE", {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2,
      })
    );
  }

  function refreshBadge(count) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  const overlay = document.createElement("div");
  overlay.className = "cart-drawer-overlay";
  overlay.id = "cart-drawer-overlay";
  overlay.hidden = true;

  const drawer = document.createElement("aside");
  drawer.className = "cart-drawer";
  drawer.id = "cart-drawer";
  drawer.hidden = true;
  drawer.setAttribute("aria-hidden", "true");
  drawer.setAttribute("role", "dialog");
  drawer.setAttribute("aria-label", "Warenkorb");

  drawer.innerHTML = `
    <div class="cart-drawer__handle" id="cart-drawer-handle" aria-hidden="true"></div>
    <div class="cart-drawer__header">
      <h2>Warenkorb</h2>
      <button type="button" class="cart-drawer__close" id="cart-drawer-close" aria-label="Warenkorb schließen">&times;</button>
    </div>
    <div class="cart-drawer__trust">
      <span><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg> Kostenloser Versand</span>
      <span><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg> 14 Tage Rückgaberecht</span>
    </div>
    <div class="cart-drawer__items" id="cart-drawer-items"></div>
    <div class="cart-drawer__footer" id="cart-drawer-footer">
      <div class="cart-drawer__subtotal">
        <span>Zwischensumme</span>
        <strong id="cart-drawer-subtotal">€0</strong>
      </div>
      <a href="/cart" class="btn btn--primary cart-drawer__checkout" id="cart-drawer-checkout">
        <span>Zum Warenkorb</span>
        <strong id="cart-drawer-checkout-price"></strong>
      </a>
    </div>
  `;

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  const itemsEl = document.getElementById("cart-drawer-items");
  const footerEl = document.getElementById("cart-drawer-footer");
  const subtotalEl = document.getElementById("cart-drawer-subtotal");
  const checkoutPriceEl = document.getElementById("cart-drawer-checkout-price");
  const closeBtn = document.getElementById("cart-drawer-close");

  // ---- Rendering -----------------------------------------------------------

  function renderDrawer(cart) {
    if (cart.item_count === 0) {
      itemsEl.innerHTML = `<div class="cart-drawer__empty">Dein Warenkorb ist leer.</div>`;
      footerEl.style.display = "none";
      return;
    }
    footerEl.style.display = "";
    itemsEl.innerHTML = cart.items
      .map(
        (item) => `
        <div class="cart-drawer__item" data-key="${item.key}" data-unit-price="${item.final_price}">
          <img src="${item.image}" alt="${item.title}" />
          <div class="cart-drawer__item-info">
            <p class="cart-drawer__item-title">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-drawer__item-price">${item.variant_title}</p>` : ""}
            <p class="cart-drawer__item-price">${formatMoney(item.final_price)}</p>
            <div class="cart-drawer__item-qty">
              <button type="button" data-drawer-qty-minus aria-label="Menge verringern">−</button>
              <span data-qty-value>${item.quantity}</span>
              <button type="button" data-drawer-qty-plus aria-label="Menge erhöhen">+</button>
            </div>
          </div>
          <button type="button" class="cart-drawer__item-remove" data-drawer-remove aria-label="Entfernen">
            <svg viewBox="0 0 24 24"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
          </button>
        </div>`
      )
      .join("");

    const formatted = formatMoney(cart.total_price);
    subtotalEl.textContent = formatted;
    checkoutPriceEl.textContent = formatted;
  }

  function renderCartPage(cart) {
    const emptyEl = document.getElementById("cart-empty");
    const layoutEl = document.getElementById("cart-layout");
    const itemsPageEl = document.getElementById("cart-items");
    if (!itemsPageEl || !layoutEl || !emptyEl) return;

    if (cart.item_count === 0) {
      emptyEl.hidden = false;
      layoutEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    layoutEl.hidden = false;

    itemsPageEl.innerHTML = cart.items
      .map(
        (item) => `
        <div class="cart-item" data-key="${item.key}" data-unit-price="${item.final_price}">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}" />
          <div>
            <p class="cart-item__title">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-item__variant">${item.variant_title}</p>` : ""}
            <p class="cart-item__price">${formatMoney(item.final_price)}</p>
            <button type="button" class="cart-item__remove" data-cart-remove>Entfernen</button>
          </div>
          <div class="cart-item__qty">
            <button type="button" data-qty-decrease aria-label="Menge verringern">−</button>
            <input type="number" min="1" inputmode="numeric" value="${item.quantity}" aria-label="Menge" data-qty-input />
            <button type="button" data-qty-increase aria-label="Menge erhöhen">+</button>
          </div>
          <div class="cart-item__linetotal" data-line-total>${formatMoney(item.final_line_price)}</div>
        </div>`
      )
      .join("");

    const subtotalPageEl = document.getElementById("cart-subtotal");
    const totalPageEl = document.getElementById("cart-total");
    if (subtotalPageEl) subtotalPageEl.textContent = formatMoney(cart.total_price);
    if (totalPageEl) totalPageEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch("/cart.js").then((r) => r.json());
  }

  function renderFromCart(cart) {
    renderDrawer(cart);
    renderCartPage(cart);
    refreshBadge(cart.item_count);
    return cart;
  }

  function refreshCartUI() {
    return fetchCart().then(renderFromCart);
  }

  // ---- Sofortige (optimistische) Aktualisierung ----------------------------

  function rowsForKey(key) {
    return document.querySelectorAll(
      `.cart-item[data-key="${key}"], .cart-drawer__item[data-key="${key}"]`
    );
  }

  function qtyOfRow(row) {
    const input = row.querySelector("[data-qty-input]");
    if (input) return Math.max(1, parseInt(input.value, 10) || 1);
    const span = row.querySelector("[data-qty-value]");
    if (span) return Math.max(1, parseInt(span.textContent, 10) || 1);
    return 1;
  }

  function writeRowQty(row, qty) {
    const input = row.querySelector("[data-qty-input]");
    if (input) input.value = qty;
    const span = row.querySelector("[data-qty-value]");
    if (span) span.textContent = qty;
    const lineTotal = row.querySelector("[data-line-total]");
    if (lineTotal) {
      const unit = parseInt(row.dataset.unitPrice, 10) || 0;
      lineTotal.textContent = formatMoney(unit * qty);
    }
  }

  // Zwischensumme + Badge lokal aus dem aktuellen DOM-Zustand berechnen.
  // Ein Artikel kann gleichzeitig im Flyout UND auf der Seite gerendert sein —
  // deshalb wird pro Key nur EINMAL gezählt.
  function recomputeTotalsLocally() {
    const seen = new Set();
    let subtotal = 0;
    let count = 0;
    document
      .querySelectorAll(".cart-item[data-key], .cart-drawer__item[data-key]")
      .forEach((row) => {
        const key = row.dataset.key;
        if (seen.has(key)) return;
        seen.add(key);
        const qty = qtyOfRow(row);
        subtotal += (parseInt(row.dataset.unitPrice, 10) || 0) * qty;
        count += qty;
      });

    const money = formatMoney(subtotal);
    [
      "cart-drawer-subtotal",
      "cart-drawer-checkout-price",
      "cart-subtotal",
      "cart-total",
    ].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.textContent = money;
    });
    refreshBadge(count);
  }

  function applyOptimistic(key, qty) {
    rowsForKey(key).forEach((row) => writeRowQty(row, qty));
    recomputeTotalsLocally();
  }

  function removeOptimistic(key) {
    rowsForKey(key).forEach((row) => row.remove());
    recomputeTotalsLocally();
  }

  // ---- Gebündelte Server-Synchronisierung ----------------------------------

  const desired = new Map(); // key -> Ziel-Menge, die noch gesendet werden muss
  const timers = new Map(); // key -> Debounce-Timer
  const inflight = new Set(); // key -> gerade eine Anfrage unterwegs

  function queueSync(key, qty, immediate) {
    desired.set(key, qty);
    clearTimeout(timers.get(key));
    if (immediate) {
      flush(key);
    } else {
      timers.set(key, setTimeout(() => flush(key), 250));
    }
  }

  function flush(key) {
    if (!desired.has(key)) return;
    if (inflight.has(key)) {
      // Läuft schon eine Anfrage für diesen Artikel — kurz warten, dann den
      // aktuellsten Wert senden.
      timers.set(key, setTimeout(() => flush(key), 120));
      return;
    }
    const qty = desired.get(key);
    inflight.add(key);

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json())
      .then((cart) => {
        // Nur autoritativ neu zeichnen, wenn der Nutzer inzwischen nicht schon
        // wieder geklickt hat — sonst würde das laufende Klicken überschrieben.
        if (desired.get(key) === qty) renderFromCart(cart);
      })
      .catch(() => {
        // Bei Netzfehler: echten Stand vom Server holen und neu zeichnen.
        refreshCartUI();
      })
      .finally(() => {
        inflight.delete(key);
        if (desired.get(key) === qty) desired.delete(key);
        else flush(key); // Nutzer hat nachgeklickt → neuesten Wert senden
      });
  }

  // Einheitlicher Einstieg für einen Mengen-Schritt.
  function step(key, qty) {
    applyOptimistic(key, qty);
    queueSync(key, qty, false);
  }

  function removeItem(key) {
    removeOptimistic(key);
    queueSync(key, 0, true);
  }

  // Rückwärtskompatible globale Hooks (falls andere Skripte sie aufrufen).
  window.ckRefreshCartDrawer = refreshCartUI;
  window.ckChangeCartItem = step;

  // ---- Flyout öffnen / schließen -------------------------------------------

  function openDrawer() {
    refreshCartUI();
    overlay.hidden = false;
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add("is-visible");
        drawer.classList.add("is-open");
      });
    });
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    overlay.classList.remove("is-visible");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(() => {
      overlay.hidden = true;
      drawer.hidden = true;
    }, 400);
  }

  window.ckOpenCartDrawer = openDrawer;

  document.querySelectorAll('a[aria-label="Warenkorb"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  // ---- Wisch-Geste zum Schließen (mobiles Bottom-Sheet) --------------------

  const handle = document.getElementById("cart-drawer-handle");
  const header = drawer.querySelector(".cart-drawer__header");
  let dragStartY = 0;
  let dragCurrentY = 0;
  let dragging = false;

  function isBottomSheet() {
    return window.matchMedia("(max-width: 640px)").matches;
  }

  function onDragStart(e) {
    if (!isBottomSheet()) return;
    dragging = true;
    dragStartY = e.touches ? e.touches[0].clientY : e.clientY;
    dragCurrentY = dragStartY;
    drawer.classList.add("cart-drawer--dragging");
  }

  function onDragMove(e) {
    if (!dragging) return;
    dragCurrentY = e.touches ? e.touches[0].clientY : e.clientY;
    const delta = Math.max(0, dragCurrentY - dragStartY);
    drawer.style.transform = `translateY(${delta}px)`;
    if (e.cancelable) e.preventDefault();
  }

  function onDragEnd() {
    if (!dragging) return;
    dragging = false;
    drawer.classList.remove("cart-drawer--dragging");
    const delta = dragCurrentY - dragStartY;
    drawer.style.transform = "";
    if (delta > 110) closeDrawer();
  }

  [handle, header].forEach((el) => {
    if (!el) return;
    el.addEventListener("touchstart", onDragStart, { passive: true });
    el.addEventListener("touchmove", onDragMove, { passive: false });
    el.addEventListener("touchend", onDragEnd);
    el.addEventListener("mousedown", (e) => {
      onDragStart(e);
      const mm = (ev) => onDragMove(ev);
      const mu = () => {
        onDragEnd();
        window.removeEventListener("mousemove", mm);
        window.removeEventListener("mouseup", mu);
      };
      window.addEventListener("mousemove", mm);
      window.addEventListener("mouseup", mu);
    });
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  // ---- Klick-Steuerung: Flyout ---------------------------------------------

  itemsEl.addEventListener("click", (e) => {
    const row = e.target.closest(".cart-drawer__item");
    if (!row) return;
    const key = row.dataset.key;
    const qty = qtyOfRow(row);

    if (e.target.closest("[data-drawer-qty-minus]")) {
      step(key, Math.max(1, qty - 1));
    } else if (e.target.closest("[data-drawer-qty-plus]")) {
      step(key, qty + 1);
    } else if (e.target.closest("[data-drawer-remove]")) {
      removeItem(key);
    }
  });

  // ---- Klick-Steuerung: Warenkorb-Seite ------------------------------------

  const cartItemsPageEl = document.getElementById("cart-items");
  if (cartItemsPageEl) {
    cartItemsPageEl.addEventListener("click", (e) => {
      const row = e.target.closest(".cart-item");
      if (!row) return;
      const key = row.dataset.key;
      const qty = qtyOfRow(row);

      if (e.target.closest("[data-qty-decrease]")) {
        step(key, Math.max(1, qty - 1));
      } else if (e.target.closest("[data-qty-increase]")) {
        step(key, qty + 1);
      } else if (e.target.closest("[data-cart-remove]")) {
        removeItem(key);
      }
    });

    // Direkte Zahleneingabe ins Feld
    cartItemsPageEl.addEventListener("change", (e) => {
      const input = e.target.closest("[data-qty-input]");
      if (!input) return;
      const row = input.closest(".cart-item");
      const key = row.dataset.key;
      const newQty = Math.max(1, parseInt(input.value, 10) || 1);
      step(key, newQty);
    });
  }

  // ---- In den Warenkorb legen (AJAX) ---------------------------------------

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo && returnTo.value === "/checkout") return;

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      const formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then((r) => r.json())
        .then((data) => {
          if (submitBtn) submitBtn.disabled = false;
          if (data.status) {
            console.error("Warenkorb-Fehler:", data.message || data.description);
            return;
          }
          openDrawer();
        })
        .catch(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
});
